import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getPayslipReport = async ({
  month,
  year,
  companyCode,
  locationCode,
  employeeCode = 0,
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  const url = isAllCompanies
    ? Api_EndPoints.AllCompanies_GetPayslip
    : Api_EndPoints.GetPayslipReport;
  let queryString =
    employeeCode !== 0
      ? `Month=${month}&Year=${year}&companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&Employee=${employeeCode}&LocationCode=${locationCode}`
      : `Month=${month}&Year=${year}&companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}`;
  if (isAllCompanies && userId !== 0) {
    queryString += `&UserId=${userId}`;
  }
  if (companyCode && locationCode) {
    const { data } = await http_payroll.get(`${url}?${queryString}`);
    return data;
  }

  return [];
};

export const usePayslipReportQuery = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetPayslip
        : Api_EndPoints.GetPayslipReport,
    ],
    queryFn: () => getPayslipReport(input),
    refetchOnWindowFocus: false,
  });
};
